module.exports = __webpack_public_path__ + "assets/icon-animalType-horse.bfbc9642.svg";